<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="Payments" :title="`Donation By Month`" />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  dense
                  :headers="headers"
                  :expanded.sync="expanded"
                  show-expand
                  :itemsPerPage="groupedPayments.length"
                  hide-default-footer
                  :items="groupedPayments"
                >
                  <template v-slot:item="{ item, isExpanded, expand }">
                    <tr>
                      <td class="text-left ">
                        <v-btn
                          class="no-print"
                          @click="expand(true)"
                          icon
                          v-if="!isExpanded"
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                        <v-btn
                          class="no-print"
                          @click="expand(false)"
                          icon
                          v-if="isExpanded"
                          ><v-icon>mdi-chevron-up</v-icon></v-btn
                        >
                      </td>
                      <td class="text-left">{{ item.month }}</td>
                      <td class="text-right">{{ item.total | currency }}</td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                      <v-card color="#F3F8FC" flat>
                        <v-card-text class="title">
													<v-card flat>
														<v-container fluid>
															<table class="center">
																<tbody class="report-container">
																	<v-card-text class="pt-0">
																		<v-data-table
																			dense
																			:sort-by="'LocalId'"
																			:headers="expandHeaders"
																			:itemsPerPage="item.payments.length"
																			hide-default-footer
																			:items="item.payments"
																		>
																			<template v-slot:item="{ item }">
																					<tr>
																						<td class="text-left">
																							{{ item.createdAt	| moment("MM/DD/YYYY")}}
																						</td>
																						<td class="text-left">
																							<a href="#" @click="viewInvoice(item.Invoice)">
																								<span v-if="item.Invoice">{{ item.Invoice.localId }}</span>
																							</a>
																						</td>
																						<td class="text-left">
																							<span v-if="item.Invoice.Customer">{{ item.Invoice.Customer.name }}</span>
																						</td>
																						<td class="text-right">{{ item.amount | currency }}</td>
																					</tr>
																			</template>
																		</v-data-table>
																	</v-card-text>
																</tbody>
															</table>
														</v-container>
													</v-card>
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                  <template
                    v-slot:body.append="{ headers }"
                    v-if="groupedPayments.length > 0"
                  >
                    <tr>
                      <td></td>
                      <td
                        :colspan="headers.length - 3"
                        class="text-right font-weight-bold"
                      >
                        Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ total | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import reportService from "@/modules/ReportView/service.js"
import { mapGetters, mapActions } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  data() {
    return {
      isLoading: true,
      Payments: null,
      start: null,
      end: null,
      expanded: [],
      groupedPayments: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "Month",
          align: "left",
          value: "month",
          sortable: false,
        },

        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
			expandHeaders: [
        {
          text: "Date",
          align: "left",
          value: "createdAt",
          sortable: false,
        },
				{
          text: "Invoice Id",
          align: "left",
          value: "Invoice.localId",
          sortable: false,
        },
				{
          text: "Customer",
          align: "left",
          value: "Invoice.Customer.name",
          sortable: false,
        },
				{
          text: "amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
			]
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    total() {
      let total = 0;
      this.groupedPayments.map((row) => {
        total += row.total;
      });

      return total;
    },
  },
  created() {
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
		viewInvoice(invoice) {
			if(invoice){
				const hashId = hashids.encode(invoice.id);
				let routeData = null;
				if (this.$route.meta.public) {
					routeData = this.$router.resolve({
						path: `/public/invoice/${hashId}/view`,
					});
				} else {
					routeData = this.$router.resolve({
						path: `/global/invoice/${hashId}/view`,
					});
				}
				window.open(routeData.href, "newwindow", "width=850, height=1100");
			}
    },
    loadData() {
      let where = {
        start: this.$route.query.start,
        end: this.$route.query.end
      }
      return reportService
        .donationPayments(where)
        .then((response) => {
          this.$Progress.finish();
          this.Payments = response.data;
          document.title = `Report - Donation Payment`;
          if(this.Payments){
						const grouped = this.Payments.reduce((acc, item) => {
							const month = new Date(item.createdAt).toLocaleString("default", { month: "long", year: "numeric" });
							if (!acc[month]) acc[month] = { month, total: 0, payments: [] };
							acc[month].total += item.amount;
							acc[month].payments.push(item);
							return acc;
						}, {});
						this.groupedPayments = Object.values(grouped).map((item, index) => ({
							id: index + 1,
							...item
						}));
          }

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
